'use client'

import { cn } from '../../utils/cn'

export interface ScreenshotProps {
  src: string
  alt: string
  browserChrome?: boolean
  shadow?: boolean
  className?: string
}

export function Screenshot({
  src,
  alt,
  browserChrome = false,
  shadow = true,
  className
}: ScreenshotProps) {
  const imageElement = (
    <img
      src={src}
      alt={alt}
      className="w-full h-auto"
    />
  )

  if (browserChrome) {
    return (
      <div
        className={cn(
          'browser-chrome',
          shadow && 'shadow-2xl shadow-black/30',
          className
        )}
      >
        <div className="browser-chrome-bar">
          <div className="browser-chrome-dot" />
          <div className="browser-chrome-dot" />
          <div className="browser-chrome-dot" />
          <div className="flex-1 mx-4">
            <div className="h-6 bg-[var(--landing-bg)] rounded-md flex items-center px-3">
              <span className="text-xs text-[var(--landing-text-muted)] truncate">
                app.vanmoose.com
              </span>
            </div>
          </div>
        </div>
        {imageElement}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'screenshot overflow-hidden',
        shadow && 'shadow-2xl shadow-black/30',
        className
      )}
    >
      {imageElement}
    </div>
  )
}
